import * as pdfIcon from '../../../../../assets/icons/file-pdf-default-gray-900.svg';
import DataUrlHelper from '../../../../helpers/data-url.helper';
import { TranslationService } from '../../../../services/translation.service';
import PressHelper from '../../helpers/press-helper';
import type IPressMaterial from '../../../../models/press/press-material.model';

function PressMaterial({ pressMaterial }: { pressMaterial: IPressMaterial }) {
  const imageSizesWidthSm = '-w_545';
  const imageSizesWidthMd = '-w_350';
  const imageSizesWidthLg = '-w_300';

  function isImage() {
    return (pressMaterial.type === 'image' || pressMaterial.type === 'logo') && pressMaterial.path.toLowerCase().endsWith('.jpg');
  }

  function getImageUrlSm() {
    return PressHelper.addSizePropertiesToImageUrl(pressMaterial.path, pressMaterial.type === 'logo' ? imageSizesWidthSm : PressHelper.defaultImageSizeCropSm);
  }

  function getImageUrlMd() {
    return PressHelper.addSizePropertiesToImageUrl(pressMaterial.path, pressMaterial.type === 'logo' ? imageSizesWidthMd : PressHelper.defaultImageSizeCropMd);
  }

  function getImageUrlLg() {
    return PressHelper.addSizePropertiesToImageUrl(pressMaterial.path, pressMaterial.type === 'logo' ? imageSizesWidthLg : PressHelper.defaultImageSizeCropLg);
  }

  function getDocumentType() {
    return pressMaterial.path.toUpperCase().split('.').pop();
  }

  function getTypeTranslated() {
    if (pressMaterial.type === 'logo') {
      return TranslationService.get('presspage.logo');
    }
    if (pressMaterial.type === 'image') {
      return TranslationService.get('presspage.image');
    }
    if (pressMaterial.type === 'document') {
      return TranslationService.get('presspage.document');
    }
    return null;
  }

  function getDownloadText() {
    return `${getDocumentType()?.toLowerCase()}, ${TranslationService.get('presspage.opensinnewwindow')}`;
  }

  return (
    <div>
      <div className="image-container d-flex align-items-center justify-content-center">
        {isImage() && (
          <picture>
            <source sizes="(min-width:992px) 350px, (min-width:768px) 301px, (min-width:576px) 354px, 545px" srcSet={`${getImageUrlLg()} 300w, ${getImageUrlMd()} 350w, ${getImageUrlSm()} 545w`} />
            <img src={getImageUrlLg()} alt="" className="mb-2 w-100" />
          </picture>
        )}
        {!isImage() && pressMaterial.type === 'document' && getDocumentType() === 'PDF' && <img src={DataUrlHelper.encode(pdfIcon.default)} alt="PDF" className="w-50" />}
      </div>
      {pressMaterial.license && <small className="mb-2">Copyright: {pressMaterial.license}</small>}
      {!pressMaterial.license && pressMaterial.credits && <small className="mb-2">Byline: {pressMaterial.credits}</small>}
      <h3>{pressMaterial.title}</h3>
      {pressMaterial.mediaFolder && <div className="mb-2">{pressMaterial.mediaFolder.name}</div>}
      {getTypeTranslated() && (
        <div className="mb-2">
          {getTypeTranslated()} | {getDocumentType()}
        </div>
      )}
      {pressMaterial.caption && <div className="mb-2">{pressMaterial.caption}</div>}
      <a href={pressMaterial.path} target="_blank" rel="noreferrer">
        {getDownloadText()}
      </a>
    </div>
  );
}

export default PressMaterial;
